import { createSlice } from "@reduxjs/toolkit";
import authService from "services/authService";
import userService from "services/userService";
import { settings } from "settings";

const initialState = {
	data: null,
	accessToken: null,
	isUserLoaded: false,
};

export const setUserData = (auth, redirectUrl) => async (dispatch) => {
	const user = await userService.getUserData();
	const payload = {
		...auth,
		data: user,
		isUserLoaded: true,
	};
	dispatch(setUser(payload));
	window.location.href = redirectUrl || settings.urls.wines;
};

export const logoutUser = () => (dispatch) => {
	authService.logout();
	dispatch(userLoggedOut());
	location.href = settings.urls.wines;
};

const userSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setUser: (state, action) => {
			return action.payload;
		},
		userLoggedOut: () => initialState,
	},
});

export const { setUser, userLoggedOut } = userSlice.actions;

export default userSlice.reducer;
